export default __webpack_public_path__ + "static/media/missing-brand.309e85b8.png";